import React from 'react';
import moment from 'moment';

type CleanRetailDeliveryEvent = {
  eventCode?: string;
  eventComment?: string;
  eventText?: string;
  eventPlace?: string;
  partner?: string;
  eventTime?: string | Date;
};

type CleanRetailDeliveryOrder = {
  hwbRefNumber?: string;
  hwbNumber?: string;
  isAttention?: boolean;
  lastEvent?: CleanRetailDeliveryEvent;
};

type RetailAttentionStatusProps = {
  retailOrder?: CleanRetailDeliveryOrder;
};

export const RetailAttentionStatus: React.FC<RetailAttentionStatusProps> = ({
  retailOrder,
}) => {
  if (!retailOrder?.isAttention) return null;

  return (
    <div className="d-flex mb-3 align-items-center gap-2">
      <i className="bi bi-exclamation-triangle-fill text-warning" />

      <div className="d-flex flex-column">
        <span className="fw-normal">
          {retailOrder.lastEvent?.eventText ??
            'Требуется дополнительная проверка заказа'}
        </span>

        {retailOrder.lastEvent?.eventTime && (
          <span className="small">
            {moment(retailOrder.lastEvent.eventTime).format('DD.MM.YYYY HH:mm')}
          </span>
        )}

        {retailOrder.lastEvent?.eventComment && (
          <span className="small">{retailOrder.lastEvent.eventComment}</span>
        )}

        {retailOrder.lastEvent?.eventPlace?.trim() && (
          <span className="small">
            Место события: {retailOrder.lastEvent.eventPlace}
          </span>
        )}

        {retailOrder.lastEvent?.eventCode?.trim() && (
          <span className="small">
            Код события: {retailOrder.lastEvent.eventCode}
          </span>
        )}
      </div>
    </div>
  );
};
